import { Skeleton, Typography } from "@mui/material";

export const TableLoader = () => {

    return (<>
        <Typography variant="h1" style={{ height: '75px' }}><Skeleton animation="wave" /></Typography>
        <Typography variant="h1" style={{ height: '75px' }}><Skeleton animation="wave" /></Typography>
        <Typography variant="h1" style={{ height: '75px' }}><Skeleton animation="wave" /></Typography>
        <Typography variant="h1" style={{ height: '75px' }}><Skeleton animation="wave" /></Typography>
        <Typography variant="h1" style={{ height: '75px' }}><Skeleton animation="wave" /></Typography>
    </>);
}